module.exports = __webpack_public_path__ + "static/feature_6-2afc90e9346afff0cc7ec114e7656889.svg";